<div class="margin-top-lg">
	<mat-card-title class="h5">
		Service Participation
		<mat-icon *ngIf="isLoading">
			<mat-spinner diameter="18"></mat-spinner>
		</mat-icon>
	</mat-card-title>
	<mat-divider> </mat-divider>

	<mat-card-content class="margin-top-lg"
		*ngIf="!isLoading && (!serviceDeliveries || serviceDeliveries.length === 0)">
		<h3>This child does not have any service participations.</h3>
	</mat-card-content>

	<div *ngIf="!isLoading && regions && regions.length > 0">

		<div *ngFor="let region of regions; let i = index" class="margin-top-md">
			<h3>Region {{region.CODE}} - {{region.NAME}}</h3>

			<div class="table-responsive">
				<mat-table [dataSource]="region.tableDataSource" class="mat-elevation-z1" matSort>
					<ng-container matColumnDef="EDIT">
						<mat-header-cell *matHeaderCellDef> </mat-header-cell>
						<mat-cell *matCellDef="let element">
							<div>
								<button mat-icon-button color="primary" (click)="viewDialog(element)" matTooltip="View">
									<mat-icon>visibility</mat-icon>
								</button>
							</div>
						</mat-cell>
					</ng-container>

					<ng-container matColumnDef="SCHOOL_YEAR">
						<mat-header-cell *matHeaderCellDef mat-sort-header> School Year </mat-header-cell>
						<mat-cell *matCellDef="let element">
							<div>
								{{element.SCHOOL_YEAR}}
							</div>
						</mat-cell>
					</ng-container>

					<ng-container matColumnDef="ENROLLMENT_PERIODS.PERIOD">
						<mat-header-cell *matHeaderCellDef mat-sort-header> Type </mat-header-cell>
						<mat-cell *matCellDef="let element">
							<div>
								{{element.ENROLLMENT_PERIODS.PERIOD}}
							</div>
						</mat-cell>
					</ng-container>

					<ng-container matColumnDef="GRADES">
						<mat-header-cell *matHeaderCellDef mat-sort-header> Grade </mat-header-cell>
						<mat-cell *matCellDef="let element">
							<div>
								{{element.GRADES}}
							</div>
						</mat-cell>
					</ng-container>

					<ng-container matColumnDef="SCHOOL_DISTRICTS.DISTRICTS">
						<mat-header-cell *matHeaderCellDef mat-sort-header> District </mat-header-cell>
						<mat-cell *matCellDef="let element">
							<div>
								{{element.SCHOOL_DISTRICTS.DISTRICTS | titlecase}}
							</div>
						</mat-cell>
					</ng-container>

					<ng-container matColumnDef="SCHOOL.NAME">
						<mat-header-cell *matHeaderCellDef mat-sort-header> School </mat-header-cell>
						<mat-cell *matCellDef="let element">
							<div>
								{{element.SCHOOL.NAME | titlecase}}
							</div>
						</mat-cell>
					</ng-container>

					<ng-container matColumnDef="SERVICE_NAME">
						<mat-header-cell *matHeaderCellDef mat-sort-header> Service Name </mat-header-cell>
						<mat-cell *matCellDef="let element">
							<div>
								{{element.SERVICE_NAME}}
							</div>
						</mat-cell>
					</ng-container>

					<ng-container matColumnDef="SERVICE_CODE">
						<mat-header-cell *matHeaderCellDef mat-sort-header> Local Code </mat-header-cell>
						<mat-cell *matCellDef="let element">
							<div>
								{{element.SERVICE_CODE}}
							</div>
						</mat-cell>
					</ng-container>

					<ng-container matColumnDef="START_DATE">
						<mat-header-cell *matHeaderCellDef mat-sort-header> Start Date </mat-header-cell>
						<mat-cell *matCellDef="let element">
							<div>
								{{element.START_DATE | cleanDate | simpleDate}}
							</div>
						</mat-cell>
					</ng-container>

					<ng-container matColumnDef="END_DATE">
						<mat-header-cell *matHeaderCellDef mat-sort-header> End Date </mat-header-cell>
						<mat-cell *matCellDef="let element">
							<div>
								{{element.END_DATE | cleanDate | simpleDate}}
							</div>
						</mat-cell>
					</ng-container>

					<ng-container matColumnDef="COS_REASONS.REASON">
						<mat-header-cell *matHeaderCellDef mat-sort-header> COS </mat-header-cell>
						<mat-cell *matCellDef="let element">
							<div>
								{{element.COS_REASONS?.REASON ? element.COS_REASONS?.REASON : '---'}}
							</div>
						</mat-cell>
					</ng-container>

					<ng-container matColumnDef="SERVICE_HOUR_RANGES.MIN">
						<mat-header-cell *matHeaderCellDef mat-sort-header> Service Hours </mat-header-cell>
						<mat-cell *matCellDef="let element">
							<div>
								{{element.SERVICE_HOUR_RANGES?.ID ? (element.SERVICE_HOUR_RANGES.MIN +
								(element.SERVICE_HOUR_RANGES.MAX ? '-' + element.SERVICE_HOUR_RANGES.MAX : '+')) :
								'---'}}
							</div>
						</mat-cell>
					</ng-container>

					<ng-container matColumnDef="CREATED_DATE">
						<mat-header-cell *matHeaderCellDef mat-sort-header> Added By / Date </mat-header-cell>
						<mat-cell *matCellDef="let element">
							{{element.CREATED_BY}} / {{element.CREATED_DATE | cleanDate | simpleDate}}
						</mat-cell>
					</ng-container>

					<mat-header-row *matHeaderRowDef="serviceDeliveryDisplayedColumns"></mat-header-row>
					<mat-row *matRowDef="let row; columns: serviceDeliveryDisplayedColumns;"></mat-row>
				</mat-table>

			</div>
		</div>

	</div>
</div>